export default __webpack_public_path__ + "static/media/login-icon.17323705.svg";